import { genNumberType } from "@visactor/vrender-core";

export const GIFIMAGE_NUMBER_TYPE = genNumberType();

export const LOTTIE_NUMBER_TYPE = genNumberType();
//# sourceMappingURL=constants.js.map